import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import type { TextCategoryItem } from '@meitu/saas-editor-ui/es/types';
import { AFTER_CREATE_EVENT, events } from '@/events-bus';
import { useElementCollapseModel } from '@/store/collapse-models/element-collapse-model';
import AllMaterialList from './components/all-material-list';
import MaterialDetailList from './components/material-detail-list';
import MaterialSearchList from './components/material-search-list';
import Search, { SearchRef } from './components/search/search';
import { TAG_TYPE } from './type';
import './material-collapse.less';

export interface IColorItem {
    id: number;
    name: string;
    color: string;
}

const MaterialCollapse = () => {
    // 全部页面中点击全部的时候触发
    const [showDetails, setShowDetails] = useState<boolean>(false);
    const [category, setCategory] = useState<TextCategoryItem | null>(null);
    const [keyword, setKeyword] = useState<string>('');
    const [color, setColor] = useState<IColorItem | null>(null);

    const [currentTag, setCurrentTag] = useState<number | TAG_TYPE>(TAG_TYPE.all);

    const searchRef = useRef<SearchRef>(null);

    const showSubBackTitle = useElementCollapseModel((state) => state.showSubBackTitle);
    const setShowSubBackTitle = useElementCollapseModel((state) => state.setShowSubBackTitle);

    const handleShowDetailsCollapse = useCallback((bool: boolean, name?: string, id?: number) => {
        setShowDetails(bool);
        if (name && id) setCategory({ name, id, materials: [] });
    }, []);

    //列表显示配置
    const listShowConfig = useMemo(() => {
        const isAllTag = currentTag === TAG_TYPE.all;
        return {
            allListStyle: {
                display: isAllTag && !showDetails && !keyword ? 'block' : 'none',
            },
            detailListStyle: {
                display: showDetails && !keyword ? 'flex' : 'none',
            },
            searchList: {
                isShow: keyword,
            },
        };
    }, [currentTag, keyword, showDetails]);

    // 创建新图片时重置
    useEffect(() => {
        const handleReset = () => {
            setShowDetails(false);
        };
        events.on(AFTER_CREATE_EVENT, handleReset);

        return () => {
            events.off(AFTER_CREATE_EVENT, handleReset);
        };
    }, []);

    // 是否显示二级标题
    useEffect(() => {
        if (!showDetails) {
            setShowSubBackTitle(false);
            return;
        }

        const isTagFilter = typeof currentTag === 'number';
        const isColor = currentTag === TAG_TYPE.colors;

        const show = !isTagFilter && !isColor;
        setShowSubBackTitle(show);
    }, [currentTag, showDetails, setShowSubBackTitle]);

    return (
        <div className="c-material-collapse">
            {/* 素材搜索 */}
            {process.env.REACT_APP_IS_INTL !== '1' && !showSubBackTitle && (
                <Search keyword={keyword} setKeyword={setKeyword} setClassType={() => {}} ref={searchRef} />
            )}

            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 1,
                }}
            >
                <AllMaterialList
                    onShowDetailsCollapse={handleShowDetailsCollapse}
                    style={listShowConfig.allListStyle}
                />

                <MaterialDetailList
                    onShowDetailsCollapse={handleShowDetailsCollapse}
                    categoryInfo={category}
                    currentTag={currentTag}
                    color={color}
                    style={listShowConfig.detailListStyle}
                />

                {listShowConfig.searchList.isShow ? <MaterialSearchList keyword={keyword} /> : null}
            </div>
        </div>
    );
};
export default React.memo(MaterialCollapse);
